import { useEffect } from 'react'
import { useMutation } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'

const PRESENCE_INTERVAL_MS = 30_000

/**
 * Fire-and-forget presence ping for a tournament participant.
 *
 * Pings once on mount, then every 30s while mounted. No state, no UI.
 * Mount this once per (tournamentId, userId) pair on whichever screen
 * should count as "user is here".
 */
export function useTournamentPresence(
  tournamentId: Id<'tournaments'> | undefined,
  userId: string | undefined
) {
  const ping = useMutation(api.tournaments.mutations.pingTournamentPresence)

  useEffect(() => {
    if (!tournamentId || !userId) return
    const doPing = () => ping({ tournamentId, userId })
    doPing()
    const id = setInterval(doPing, PRESENCE_INTERVAL_MS)
    return () => clearInterval(id)
  }, [tournamentId, userId, ping])
}
